import { render, staticRenderFns } from "./ListRewardDetail.vue?vue&type=template&id=25927a4c"
import script from "./ListRewardDetail.vue?vue&type=script&lang=js"
export * from "./ListRewardDetail.vue?vue&type=script&lang=js"
import style0 from "./ListRewardDetail.vue?vue&type=style&index=0&id=25927a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports